import { View } from 'backbone.marionette';
import _ from 'lodash';
import Backbone from 'backbone';
// import Syphon from 'backbone.syphon';

import showModal from '@/util/showModal';
import PageableCollection from '@/backbone/PageableCollection';
import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';

import CommandCustomerGridView from '../CommandCustomerGridView';
import UserSearchModalView from '../../../administration/views/UserSearchModalView/UserSearchModalView';
import AddUserCommandAccessByExternalUserIDAndCommandID from '../../services/AddUserCommandAccessByExternalUserIDAndCommandID';

import tmplCommandCustomerView from './CommandCustomerView.hbs';

const CommandCustomerView = View.extend({
  template: tmplCommandCustomerView,

  className: 'command-customer-view',

  ui: {
    commandCustomerGrid: '.command-customer-grid-container',
    btnAddCustomer: '.btn-add-customer'
  },

  regions: {
    commandCustomerGrid: '@ui.commandCustomerGrid'
  },

  events: {
    'click @ui.btnAddCustomer': 'onClickAddCustomer'
  },

  onRender() {
    this.renderCustomerGrid();
  },

  renderCustomerGrid() {
    this.commandCustomerCollection = new PageableCollection(this.model.get('customers'));

    this.commandCustomerGridView = new CommandCustomerGridView({
      model: new Backbone.Model({
        collection: this.commandCustomerCollection,
        commandId: this.model.get('commandId')
      })
    });
    this.showChildView('commandCustomerGrid', this.commandCustomerGridView);
    //this.commandCustomerGridView.getViewGrid().sort('statusId', 'descending');
  },

  async onClickAddCustomer() {
    const self = this;
    try {
      await showModal({
        title: 'Select User',
        view: new UserSearchModalView({
          model: new Backbone.Model({
            searchType: 'External'
          })
        }),
        dialogClasses: 'modal-lg'
      }).then(async (user) => {
        if (_.find(self.commandCustomerCollection.fullCollection.toJSON(), { id: user.id })) {
          this.showUserAlreadyExistsError();
          return;
        }
        user.fullName = `${user.firstName} ${user.lastName}`;
        user.userId = user.otdsUserId;
        user.phone = user.telephone;
        const userID = user.id;
        const command = { id: this.model.get('commandId').commandId };
        await AddUserCommandAccessByExternalUserIDAndCommandID(userID, command);
        this.showAddSuccess();
        self.commandCustomerCollection.fullCollection.add(user);
      });
    } catch (err) {
      this.showAddError();
    }
  },

  showAddSuccess() {
    showSuccessMessage({
      code: 'addSuccess',
      title: 'Customer Added',
      message: 'Customer successfully added to command.',
      hideAfter: 5
    });
  },

  showUserAlreadyExistsError() {
    showErrorMessage({
      errorCode: 'addError',
      errorTitle: 'Customer Add Error',
      errorMessage: 'Customer already has access to command.'
    });
  },
  showAddError() {
    showErrorMessage({
      errorCode: 'addError',
      errorTitle: 'Customer Add Error',
      errorMessage: 'An error occurred while giving access to the command to the user. Try again or contact an administrator if your issue persists.'
    });
  }
});

export default CommandCustomerView;
